import React from "react";
import { Descriptions } from "antd";

import { formatFirstname, formatLastname } from '../../utils';

import moment from "moment";

const SurgicalInterventionSummary = (props) => {
  const { surgicalIntervention } = props;

  let { patient=null, surgical_procedure=null, doctor=null, care_unit=null } = surgicalIntervention || {};

  let patientName = (patient)
    ? [
        formatFirstname(patient.firstname),
        formatLastname(patient.lastname),
      ].join(' ')
    : null;
  let doctorName = (doctor)
    ? [
        formatFirstname(doctor.firstname),
        formatLastname(doctor.lastname),
      ].join(' ')
    : null;
  let startDate = (surgicalIntervention)
    ? moment(surgicalIntervention.start_at).format("dddd DD MMM YYYY")
    : null;
  let expectedEndAt = (surgicalIntervention)
    ? moment(surgicalIntervention.expected_end_at).format("dddd DD MMM YYYY")
    : null;
  let careUnitName = (care_unit) ? care_unit.name : null;

  return (
    <Descriptions title="Récapitulatif" bordered>
      <Descriptions.Item label="Patient"  span={3}>
        {patientName}
      </Descriptions.Item>
      <Descriptions.Item label="Unité initiale"  span={3}>
        {careUnitName}
      </Descriptions.Item>
      <Descriptions.Item label="Chirurgien"  span={3}>
        {doctorName}
      </Descriptions.Item>
      <Descriptions.Item label="Procédure"  span={3}>
        {surgical_procedure ? surgical_procedure.name : null}
      </Descriptions.Item>
      <Descriptions.Item label="Date d'entrée"  span={3}>
        {startDate}
      </Descriptions.Item>
      <Descriptions.Item label="Date de sortie envisagée"  span={3}>
        {expectedEndAt}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default SurgicalInterventionSummary;
